import { ArrowUpRight } from "lucide-react";
import { SHOP_URL } from "../data/content";

export default function GuidebookCard({ book }) {
  return (
    <article
      data-testid="guidebook-card-item"
      className="group relative flex h-full flex-col border border-white/[0.08] bg-[#0F121B]/70 p-6 transition-all duration-500 hover:border-[#8B5CF6]/40 hover:shadow-[0_0_40px_rgba(139,92,246,0.12)] sm:p-8"
    >
      <div
        className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[#8B5CF6]/70 to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100"
        aria-hidden="true"
      />
      <div className="flex items-center justify-between gap-4">
        <span className="text-[10px] font-mono-ui uppercase tracking-[0.24em] text-[#A78BFA]">
          {book.category}
        </span>
        <span className="coordinate-badge">{book.coord}</span>
      </div>
      <h3 className="font-display mt-6 text-2xl leading-snug text-[#F0F2F8]">
        {book.title}
      </h3>
      {book.badge && (
        <span className="mt-4 inline-flex w-fit items-center border border-[#8B5CF6]/40 bg-[#8B5CF6]/10 px-2.5 py-1 text-[10px] font-mono-ui uppercase tracking-[0.2em] text-[#A78BFA]">
          {book.badge}
        </span>
      )}
      <p className="body-muted mt-4 flex-1 text-sm leading-relaxed">
        {book.description}
      </p>
      <p className="mt-6 text-[11px] font-mono-ui uppercase tracking-[0.14em] text-[#5F6677]">
        {book.format}
      </p>
      <a
        data-testid="guidebook-buy-fourthwall-btn"
        href={SHOP_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="mt-6 inline-flex items-center justify-between gap-3 border border-white/15 px-4 py-3 text-[11px] font-mono-ui uppercase tracking-[0.2em] text-[#F0F2F8] transition-all duration-300 hover:border-[#8B5CF6] hover:bg-[#8B5CF6]/10 hover:shadow-[0_0_24px_rgba(139,92,246,0.25)]"
      >
        Order on Fourthwall
        <ArrowUpRight className="h-3.5 w-3.5 text-[#A78BFA]" />
      </a>
    </article>
  );
}
